export default __webpack_public_path__ + "static/media/ic_groups.6f3a44cf.svg";